import { useEffect, useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { backendConfigured, supabase } from '../lib/supabase';
import { getCurrentHouseholdId } from '../lib/api';

function PublicWelcomeRedirect() {
  // A full navigation loads the static page without the private application bundle.
  useEffect(() => { window.location.replace('/welcome/'); }, []);
  return <div className="auth-loading"><a href="/welcome/">Explore Weekstead →</a></div>;
}

export default function AuthGate({ children, requireHousehold = true }: { children: ReactNode; requireHousehold?: boolean }) {
  const [ready, setReady] = useState(!backendConfigured);
  const [authenticated, setAuthenticated] = useState(!backendConfigured);
  const [hasHousehold, setHasHousehold] = useState(!backendConfigured);
  const location = useLocation();

  useEffect(() => {
    if (!supabase) return;
    let alive = true;
    async function resolve() {
      const { data } = await supabase.auth.getSession();
      if (!alive) return;
      const signedIn = Boolean(data.session);
      setAuthenticated(signedIn);
      if (signedIn && requireHousehold) {
        try { setHasHousehold(Boolean(await getCurrentHouseholdId())); }
        catch { setHasHousehold(false); }
      } else if (signedIn) setHasHousehold(true);
      setReady(true);
    }
    void resolve();
    const { data: listener } = supabase.auth.onAuthStateChange(() => void resolve());
    return () => { alive = false; listener.subscription.unsubscribe(); };
  }, [requireHousehold]);

  if (!ready) return <div className="auth-loading">Opening your household…</div>;
  if (!authenticated && location.pathname === '/') return <PublicWelcomeRedirect />;
  if (!authenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (requireHousehold && !hasHousehold) return <Navigate to="/onboarding" replace />;
  return children;
}
